import SessionCard from "../../trading-sessions/SessionCard";
import { useDashboardData } from "./DashboardDataContext";

export default function SessionWidget() {
  return <div className="h-full"><SessionCard /></div>;
}
